<template>
    <div class="configurador-lstCarsSwiper">
        <swiper class="lstCarsSwiper" ref="ListModelsHp" :options="swiperOptions"  >
            <swiper-slide v-for="(item, i) in carsLst" :key="i">
                <CarCard :modelObj="item" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>
<script>
    import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
    import SwiperCore, { Navigation, Pagination } from 'swiper';
    SwiperCore.use([Navigation, Pagination]);
    import 'swiper/swiper-bundle.css'
    import CarCard from '../../Cards/CarCard/CarCard.vue'

    export default {
        name: 'ListCarsSwiper',
        components: { Swiper, SwiperSlide, CarCard },
        props: {
            carsLst: { type: Array, default: () => { return []; }},
        },
        directives: {
            swiper: directive
        },
        data(){return{
            swiperOptions: {
                spaceBetween: 20,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'progressbar'
                },
                breakpoints:{
                    0: { slidesPerView: 1 },
                    767: { slidesPerView: 2 },
                    992:{ slidesPerView: 3 },
                }
            },
        }},
        computed: {
            swiper(){
                return this.$refs.ListModelsHp.$swiper
            }
        },
    }
</script>
<style lang="scss">
    .lstCarsSwiper{
        padding-bottom: 1.25rem;
        margin-bottom: 1.25rem;
        .swiper-pagination-progressbar{
            background-color: $grayLighterCol;
            top: unset;
            bottom: 0;
            &-fill{ background: $primaryCol;}
        }
    }
</style>